import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { ITicketResponse } from '../ticket-response';
import { ticketResponseSchema } from '../ticket-response';
import type { IUpdateTicketTitleRequest } from './update-ticket-title-request';

export async function updateTicketTitleApi(
  id: number,
  body: IUpdateTicketTitleRequest,
): Promise<IValidatedResponse<ITicketResponse>> {
  return putRequest<ITicketResponse>({
    path: `/sys/ticket/${id}/title`,
    body,
    schema: ticketResponseSchema,
  });
}
